import { AddStaticText } from "./AddStaticText";

export function AddStaticText2(panel, xPos, yPos, label, bold, textColor, fontName, fontSize) {
  var st = AddStaticText(panel, xPos, yPos, label, bold, textColor);
  st.SetFontName(fontName);
  st.SetFontSize(fontSize);
  return st;
}
